import React from 'react';
import { useRecordContext } from 'react-admin';

import ChipField, { getChipColors } from '../../common/fields/ChipField';

const statusConfig = {
    draft: { label: 'Draft', color: 'default' },
    todo: { label: 'Todo', color: 'info' },
    in_progress: { label: 'In Progress', color: 'primary' },
    paused: { label: 'Paused', color: 'warning' },
    done: { label: 'Done', color: 'success' },
    canceled: { label: 'Canceled', color: 'error' }
};

const StatusField = ({ source = 'status', size = 'small' }) => {
    const record = useRecordContext();
    if (!record || !record[source]) {
        return null;
    }

    const status = record[source];
    const config = statusConfig[status] || { label: status, color: 'default' };

    return (
        <ChipField
            source={source}
            record={{ [source]: config.label }}
            size={size}
            sx={getChipColors(config.color)}
        />
    );
};

export default StatusField;
